import { useContext, useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { AuthContext, hasScope as getHasScope } from 'automation-ui-core/context/AuthContext';
import { cleanGatedAssociationDefinitions } from 'automation-ui-associations/utils/cleanGatedAssociationDefinitions';
import { PAYMENTS_POST_UNDERWRITING_ACCESS, SUBSCRIPTIONS_ACCESS, INVOICES_READ, PARTNER_CLIENT_READ, PARTNER_ACCOUNT_READ, PARTNER_SERVICE_READ, PARTNER_ACCOUNT_OBJECT_ACCESS } from 'automation-ui-associations/constants/Scopes';
import { GET_ASSOCIATION_DEFINITIONS } from 'automation-ui-associations/queries/associationDefinitionsQuery';
const DEFAULT_ASSOCIATION_DEFINITIONS = {
  allDefinitions: []
};
export const useAssociationDefinitions = fromObjectTypeIds => {
  const {
    user
  } = useContext(AuthContext);
  const filteredFromObjectTypeIds = fromObjectTypeIds && fromObjectTypeIds.filter(id => !!id);
  const query = useQuery(GET_ASSOCIATION_DEFINITIONS, {
    skip: !filteredFromObjectTypeIds || !filteredFromObjectTypeIds.length,
    variables: {
      objectTypeIds: filteredFromObjectTypeIds
    }
  });
  const cleanedAssociationDefinitions = useMemo(() => {
    const hasScope = getHasScope(user && user.scopes || []);
    const hasSubscriptionObjectAccess = hasScope(SUBSCRIPTIONS_ACCESS);
    const hasPaymentObjectAccess = hasScope(PAYMENTS_POST_UNDERWRITING_ACCESS);
    const hasInvoiceAccess = hasScope(INVOICES_READ);
    const hasPartnerClientAccess = hasScope(PARTNER_CLIENT_READ);
    const hasPartnerAccountAccess = hasScope(PARTNER_ACCOUNT_READ) && hasScope(PARTNER_ACCOUNT_OBJECT_ACCESS);
    const rawAssociationDefinitions = query.data ? query.data.associations_associationDefinitions : DEFAULT_ASSOCIATION_DEFINITIONS;
    const hasPartnerServiceAccess = hasScope(PARTNER_SERVICE_READ);
    return cleanGatedAssociationDefinitions(rawAssociationDefinitions, {
      hasSubscriptionObjectAccess,
      hasPaymentObjectAccess,
      hasInvoiceAccess,
      hasPartnerClientAccess,
      hasPartnerAccountAccess,
      hasPartnerServiceAccess
    });
  }, [query.data, user]);
  return Object.assign({}, query, {
    previousData: query.previousData ? query.previousData.associations_associationDefinitions : DEFAULT_ASSOCIATION_DEFINITIONS,
    data: cleanedAssociationDefinitions
  });
};